import React from 'react'
import { useTopToolbar } from '../../context/TopToolbarContext'
import ToolbarButton from './ToolbarButton'
import { MdEmail, MdHistory, MdSettings, MdNotifications } from 'react-icons/md'
import { useLocation } from 'react-router-dom'
import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import './Toolbar.css'

const SimpleToolbar = () => {
  const { content } = useTopToolbar()
  const navigate = useNavigate()

  const left = content && content.left ? content.left : null
  const injectedRight = content && content.right ? content.right : null
  const location = useLocation()
  const [notifVisible, setNotifVisible] = useState(false)
  const [notifications, setNotifications] = useState([])

  useEffect(() => {
    const key = 'app_notifications'
    try {
      const raw = localStorage.getItem(key)
      const all = raw ? JSON.parse(raw) : {}
      const combined = []
      const seen = new Set()
      Object.keys(all).forEach((k) => {
        try {
          if (!k || typeof k !== 'string') return
          // include when key is exact match, parent path, or child path
          if (
            location.pathname.startsWith(k) ||
            k.startsWith(location.pathname) ||
            k === location.pathname
          ) {
            const arr = Array.isArray(all[k]) ? all[k] : []
            arr.forEach((it) => {
              const sig = (it.title || '') + '||' + (it.message || '')
              if (!seen.has(sig)) {
                seen.add(sig)
                combined.push(it)
              }
            })
          }
        } catch (err) {
          // ignore per-key errors
        }
      })
      setNotifications(combined)
    } catch (e) {
      setNotifications([])
    }
    setNotifVisible(false)
  }, [location.pathname])

  // listen for external updates to app_notifications (other components may write to localStorage)
  useEffect(() => {
    const handler = () => {
      console.debug(
        '[SimpleToolbar] appNotificationsUpdated event received for',
        location.pathname
      )
      const key = 'app_notifications'
      try {
        const raw = localStorage.getItem(key)
        const all = raw ? JSON.parse(raw) : {}
        // Same aggregation logic as above
        const combined = []
        const seen = new Set()
        Object.keys(all).forEach((k) => {
          try {
            if (!k || typeof k !== 'string') return
            if (
              location.pathname.startsWith(k) ||
              k.startsWith(location.pathname) ||
              k === location.pathname
            ) {
              const arr = Array.isArray(all[k]) ? all[k] : []
              arr.forEach((it) => {
                const sig = (it.title || '') + '||' + (it.message || '')
                if (!seen.has(sig)) {
                  seen.add(sig)
                  combined.push(it)
                }
              })
            }
          } catch (err) {}
        })
        console.debug(
          '[SimpleToolbar] loaded notifications from storage',
          combined
        )
        setNotifications(combined)
      } catch (e) {
        setNotifications([])
      }
    }
    window.addEventListener('appNotificationsUpdated', handler)
    return () => window.removeEventListener('appNotificationsUpdated', handler)
  }, [location.pathname])

  const markAllRead = () => {
    const key = 'app_notifications'
    try {
      const raw = localStorage.getItem(key)
      const all = raw ? JSON.parse(raw) : {}
      all[location.pathname] = []
      localStorage.setItem(key, JSON.stringify(all))
      setNotifications([])
    } catch (e) {
      // ignore
    }
  }

  return (
    <div className='simple-top-toolbar'>
      <div className='simple-top-toolbar-inner'>
        <div className='simple-top-toolbar-left'>{left}</div>
      </div>
    </div>
  )
}

export default SimpleToolbar
